'use client';

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { AuthLayout } from '@/features/authentication/presentation/components/AuthLayout';
import { Button } from '@/core/presentation/components/ui/Button';
import { ChoosePlanView } from '@/features/plans/presentation/components/ChoosePlanView';
import { useChoosePlanBridge } from '@/features/plans/presentation/composables/bridges/ChoosePlanBridge';

/**
 * Escolha de plano — layout + view + rodapé “voltar ao login”; dados e checkout vêm de {@link useChoosePlanBridge}.
 */
export const ChoosePlanScreen: React.FC = () => {
  const { layout, view, exitFooter } = useChoosePlanBridge();

  return (
    <AuthLayout
      title={layout.title}
      maxWidthClassName="max-w-5xl"
      footer={
        <Button
          type="button"
          variant="ghost"
          size="sm"
          loading={exitFooter.loading}
          loadingLabel={exitFooter.loadingLabel}
          onClick={() => void exitFooter.onExit()}
          className="font-medium text-cyan hover:text-cyan-light hover:underline hover:underline-offset-2 hover:bg-transparent focus-visible:underline focus-visible:underline-offset-2 focus-visible:ring-2 focus-visible:ring-cyan"
        >
          <span className="relative inline-block">
            <ArrowLeft
              className="pointer-events-none absolute right-full top-1/2 mr-4 size-4 shrink-0 -translate-y-1/2"
              aria-hidden
            />
            {exitFooter.label}
          </span>
        </Button>
      }
    >
      <ChoosePlanView {...view} />
    </AuthLayout>
  );
};
